import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col items-center justify-center px-4 py-24 text-center">
      <span className="font-heading text-7xl font-black text-background-300 select-none md:text-9xl">404</span>
      <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">抱歉，这个页面走远了</h1>
      <p className="mt-3 text-sm text-foreground-600">
        你访问的地址 <span className="font-mono text-foreground-800">{location.pathname}</span> 暂时不存在或已下线。
      </p>
      <div className="mt-8 flex flex-col items-center gap-3 sm:flex-row">
        <Link
          to="/"
          className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 sm:w-auto"
        >
          <i className="ri-home-4-line text-base" />
          返回首页
        </Link>
        <Link
          to="/category/all"
          className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700 sm:w-auto"
        >
          <i className="ri-compass-3-line text-base" />
          浏览全部影视
        </Link>
      </div>
    </div>
  );
}